<template>

    <SubHeader title="Liste des Institutions" :breads="[{ name: 'Institutions' }]" :action="{}" />
    <div class="row">
        <div class="col-md-12">
            <div class="card">
                <div class="card-header">
                    <div class="row justify-content-between align-items-center flex-grow-1">
                        <div class="col-12 col-md">
                            <div class="d-flex justify-content-between align-items-center" v-if="checkGuard('create_institution')">
                                <router-link :to="{ name: 'AdminConfigCreateInstitution' }"
                                    class="btn btn-outline-primary btn-xs">
                                    <i class="bi bi-plus me-1"></i> Ajouter
                                </router-link>
                                
                            </div>
                        </div>

                        <div class="col-auto">
                            <!-- Filter -->
                            <form>
                                <!-- Search -->
                                <div class="input-group input-group-merge input-group-flush">
                                    <div class="input-group-prepend input-group-text">
                                        <i class="bi-search"></i>
                                    </div>
                                    <input id="datatableWithSearchInput" v-model="searchWord" type="search" class="form-control"
                                        placeholder="Search institution" aria-label="Search institution">
                                </div>
                                <!-- End Search -->
                            </form>
                            <!-- End Filter -->
                        </div>
                    </div>
                </div>
                <div class="card-body datatable-custom position-relative">
                    
                    <data-table :rows="items" :columns="cols" :loading="isLoading" 
                        :sortable="true" sortColumn="id" sortDirection="desc" paginationInfo="De {0} à {1} sur un total de {2}"
                        :search="searchWord" noDataContent="Pas de resultat"
                        class="advanced-table whitespace-nowrap table table-borderless table-thead-bordered ">
                        <template #action="{value}">
                            <div class="btn-group"  role="group" aria-label="Button group with nested dropdown">
                     
                                        <!-- a href="" class="btn btn-outline-dark btn-xs" title="Voir le résumé"><i class="bi bi-eye"></i></a -->
                                        <router-link :to="{ name: 'AdminConfigShowInstitution', params: { id: value.id } }"
                                            class="btn btn-outline-dark btn-xs" title="Voir la fiche">
                                            <i class="bi bi-eye"></i>
                                        </router-link>
                                    </div>
                        </template>
                    </data-table>
                </div>
              
            </div>
        </div>
    </div>
</template>
<script>

import SubHeader from "@/layouts/admin/SubHeader.vue";
// import { mapActions } from "vuex";
import { mapFields } from "vuex-map-fields";
import { mapActions } from "vuex"
import {checkGuard} from "@/utils/guards.js"
export default {
    name: "AdminConfigInstitutions",
    components: {
        SubHeader
    },
    data() {
        return {
            cols: [
                { field: 'id', title: '', sort: false, width: '0px',type:'number',cellRenderer(){ return ""} },
                { field: 'label', title: 'Institution' },
                { field: 'email', title: 'Contacts',cellRenderer({email,phone}){ return `${phone ?? ''}  ${email ?? ''} `}  },
                { field: 'institution_type.label', title: 'Type' },
                { field: 'action', title: 'Actions', sort: false, width: '10px', headerClass: 'justify-center', cellClass: 'justify-center',hide:!this.checkGuard('view_institution') },

            ],
            searchWord:null
        }
    },

    computed: {
        ...mapFields("institution/list", {
            isLoading: "isLoading",
            isSuccess: "isSuccess",
            showMessage: "showMessage",
            message: "message",
            items: "items"

        }),
      
    },

    methods: {
        ...mapActions({
            getInstitutions: "institution/list/getAll",
            reset: "institution/list/resetData",
        }),
        checkGuard,
    },
    mounted() {
        this.getInstitutions()
    },
    unmounted(){
        this.reset()
    }
}
</script>
